import { c as _c } from "react/compiler-runtime";
import type { ColumnHeaderGroup } from "@/utils/column-header-groups";
import cn from "twsx";
import styles from "./List.module.css";
export type ColumnGroupHeaderLayout = ColumnHeaderGroup & {
  stickyOffset?: string;
  pinnedWidth?: string;
  leadingClip?: string;
  trailingClip?: string;
};

/** Optional shared header tier; the ordinary column row remains the sorting/selection owner. */
export default function ColumnGroupHeaders(t0) {
  const $ = _c(5);
  const {
    groups
  } = t0;
  if (!groups.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid list-table-subgrid", styles.columnGroups);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== groups) {
    t2 = groups.map(_temp);
    $[1] = groups;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={t1} role="row">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(group) {
  return <div key={group.start} role={group.label ? "columnheader" : undefined} aria-colspan={group.label ? group.span : undefined} aria-hidden={!group.label} data-labelled={group.label ? true : undefined} data-pinned={group.stickyOffset ? true : undefined} className={cn(styles.columnGroup, "font-semibold text-text-primary")} style={{
    gridColumn: `${group.start + 1} / span ${group.span}`,
    left: group.stickyOffset,
    minWidth: group.pinnedWidth,
    width: group.pinnedWidth ? `max(${group.pinnedWidth}, calc(100% - var(--list-scroll-left, 0px)))` : undefined
  }}><span className="flex min-w-0 shrink-0 items-center justify-center overflow-hidden whitespace-nowrap" style={{
      marginLeft: group.leadingClip,
      width: group.leadingClip || group.trailingClip ? `max(0px, calc(100% - ${group.leadingClip ?? "0px"} - ${group.trailingClip ?? "0px"}))` : "100%"
    }}>{group.label}</span></div>;
}